import React, { useState, useEffect } from "react";
import axios from "axios";
import { useSelector, useDispatch } from "react-redux";
import SyncConstants from "../../constants/SyncConstants";
import useAuthentication from "../../hooks/useAuthentication";
import { set_notification } from "../../actions/Sync";
import moment from "moment";

const ExternalCostMask = (props) => {
    const Auth = useAuthentication();
    const dispatch = useDispatch();
    const CurrentUser = useSelector((state) => state.CurrentUser);
    const Team = useSelector((state) => state.Team);
    const UserSettings = useSelector((state) => state.User);
    
    const [amount, setAmount] = useState(props.updateEntry?.amount || "");
    const [description, setDescription] = useState(props.updateEntry?.description || "");
    const [invoiceNumber, setInvoiceNumber] = useState(props.updateEntry?.invoice_number || "");
    const [date, setDate] = useState(props.updateEntry?.date || moment().format('YYYY-MM-DD'));
    const [selectedPerson, setSelectedPerson] = useState(props.updateEntry?.person || CurrentUser.userName);
    const [bookForOther, setBookForOther] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (!amount || parseFloat(amount) <= 0) {
            dispatch(set_notification("Bitte einen gültigen Betrag eingeben", "error"));
            return;
        }
        
        if (!description || description.trim() === "") {
            dispatch(set_notification("Bitte eine Beschreibung eingeben", "error"));
            return;
        }
        
        // Validierung: Wenn "Für andere Person buchen" aktiv ist, muss eine Person ausgewählt sein
        if (bookForOther && (!selectedPerson || selectedPerson === '')) {
            dispatch(set_notification("Bitte wähle eine Person aus", "error"));
            return;
        }
        
        setIsSubmitting(true);
        
        const data = {
            updateId: props.updateEntry?.id || 0,
            expenseProjectId: props.projectId,
            amount: parseFloat(amount),
            description: description.trim(),
            invoiceNumber: invoiceNumber.trim(),
            date: date,
            person: selectedPerson,
            bookedBy: selectedPerson !== CurrentUser.userName ? CurrentUser.userName : null
        };
        
        console.log("Sending External Cost Data:", data);
        console.log("Selected Person:", selectedPerson, "Current User:", CurrentUser.userName);
        
        axios({
            method: "post",
            auth: Auth.getAuthObject(),
            url: SyncConstants["syncBaseURL"] + "externalCost",
            data: data,
            responseType: 'json'
        }).then((response) => {
            dispatch(set_notification(
                props.updateEntry ? "Externe Kosten aktualisiert" : "Externe Kosten erstellt",
                "success"
            ));
            setIsSubmitting(false);
            if (props.onSuccess) {
                props.onSuccess();
            }
        }).catch((error) => {
            dispatch(set_notification("Fehler beim Speichern", "error"));
            setIsSubmitting(false);
        });
    };
    
    const handleCancel = () => {
        if (props.onCancel) {
            props.onCancel();
        }
    };

    return (
        <div className="external-cost-mask">
            <form onSubmit={handleSubmit}>
                <div className="row">
                    <div className="col-6">
                        <div className="form-group">
                            <h6>Betrag (EUR) <span className="text-danger">*</span></h6>
                            <div className="input-group">
                                <input
                                    type="number"
                                    className="form-control"
                                    value={amount}
                                    onChange={(e) => setAmount(e.target.value)}
                                    step="0.01"
                                    min="0"
                                    placeholder="0.00"
                                    required
                                    autoFocus
                                />
                                <span className="input-group-text">€</span>
                            </div>
                            <span className="small text-muted ms-1">Betrag der externen Kosten.</span>
                        </div>
                    </div>

                    <div className="col-6">
                        <div className="form-group">
                            <h6>Datum <span className="text-danger">*</span></h6>
                            <input
                                type="date"
                                className="form-control"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                required
                            />
                            <span className="small text-muted ms-1">Datum der Kostenerfassung.</span>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="form-group">
                            <h6>Beschreibung <span className="text-danger">*</span></h6>
                            <textarea
                                className="form-control"
                                value={description}
                                onChange={(e) => setDescription(e.target.value)}
                                rows="3"
                                placeholder="Beschreibung der Kosten..."
                                required
                            />
                            <span className="small text-muted ms-1">Detaillierte Beschreibung der externen Kosten.</span>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="form-group">
                            <h6>Rechnungs-/Referenznummer</h6>
                            <input
                                type="text"
                                className="form-control"
                                value={invoiceNumber}
                                onChange={(e) => setInvoiceNumber(e.target.value)}
                                placeholder="z.B. RE-2024-001"
                            />
                            <span className="small text-muted ms-1">Optional: Rechnungsnummer zur Zuordnung.</span>
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="form-group">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="bookForOtherCheck"
                                    checked={bookForOther}
                                    onChange={e => {
                                        setBookForOther(e.target.checked);
                                        if (!e.target.checked) {
                                            setSelectedPerson(CurrentUser.userName);
                                        } else {
                                            // Wenn Checkbox aktiviert wird, setze auf leeren Wert
                                            setSelectedPerson('');
                                        }
                                    }}
                                />
                                <label className="form-check-label" htmlFor="bookForOtherCheck">
                                    Für andere Person buchen
                                </label>
                            </div>

                            {bookForOther && (
                                <div className="mt-2">
                                    <select
                                        value={selectedPerson}
                                        className={`form-select ${!selectedPerson ? 'is-invalid' : ''}`}
                                        onChange={e => setSelectedPerson(e.target.value)}
                                        required={bookForOther}
                                    >
                                        <option value="">-- Bitte Person wählen --</option>
                                        {Object.keys(Team)
                                            .sort((a, b) => Team[a].realName.localeCompare(Team[b].realName))
                                            .map(username => (
                                                <option key={username} value={username}>
                                                    {Team[username].realName}
                                                </option>
                                            ))
                                        }
                                    </select>
                                    {selectedPerson && selectedPerson !== CurrentUser.userName && (
                                        <span className="small text-muted ms-1">
                                            Wird als {Team[CurrentUser.userName]?.realName} für {Team[selectedPerson]?.realName} gebucht
                                        </span>
                                    )}
                                    {!selectedPerson && (
                                        <div className="invalid-feedback d-block">
                                            Bitte wähle eine Person aus
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>

                <div className="row mt-4">
                    <div className="col-12">
                        <div className="d-flex justify-content-end gap-2">
                            <button
                                type="button"
                                className="btn btn-secondary"
                                onClick={handleCancel}
                                disabled={isSubmitting}
                            >
                                Abbrechen
                            </button>
                            <button
                                type="submit"
                                className="btn btn-primary"
                                disabled={isSubmitting}
                            >
                                {isSubmitting ? (
                                    <>
                                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                        Speichert...
                                    </>
                                ) : (
                                    <>
                                        <i className="bi bi-check-lg me-1"></i>
                                        {props.updateEntry ? "Aktualisieren" : "Speichern"}
                                    </>
                                )}
                            </button>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default ExternalCostMask;
